import React, {useEffect, useState} from 'react'
import {restRequest} from '../../../api-utils/apiQueries'
import {KTIcon} from '../../../_metronic/helpers'
import {useNavigate} from 'react-router-dom'
import Pagination from '../../common-function/Pagination'
import SearchQueryData from '../../common-function/SearchQueryData'
import {ExportReportPayload, useExportReport} from '../../common-function/downloadExportFile'
import {useAdminListState} from '../../common-function/useAdminListState'

type MatesListFilter = Record<string, never>

const MatesManagementWrapper = () => {
  const {runExport, exporting} = useExportReport()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [mates, setMates] = useState<any>([])
  const [totalPages, setTotalPages] = useState(0)
  const {page, setPage, searchQuery, setSearchQuery, resetPageForSearch} =
    useAdminListState<MatesListFilter>({
      storageKey: 'mates-management',
      getDefaultFilter: () => ({}),
    })
  const [checkedMates, setCheckedMates] = useState<any[]>([])

  const navigate = useNavigate()

  const isAllChecked = mates.length > 0 && checkedMates.length === mates.length

  const handleHeaderCheckboxChange = (e: any) => {
    if (e.target.checked) {
      // Check all users
      const allMateIds = mates.map((mate: any) => mate.id)
      setCheckedMates(allMateIds)
    } else {
      // Uncheck all users
      setCheckedMates([])
    }
  }

  // Handle individual checkbox change
  const handleCheckboxChange = (userId: any) => {
    setCheckedMates(
      (prevChecked) =>
        prevChecked.includes(userId)
          ? prevChecked.filter((id) => id !== userId) // Uncheck
          : [...prevChecked, userId] // Check
    )
  }

  const fetchUsersMatesData = async (query: string) => {
    setIsLoading(true)
    let response: any = await restRequest.getMatesData(page, query)
    let data = response.data.data
    setMates(data.data)
    setTotalPages(data.pager.totalPages)
    setIsLoading(false)
  }

  useEffect(() => {
    fetchUsersMatesData(searchQuery)
  }, [page])

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value)
    if (e.target.value === '') {
      resetPageForSearch()
      fetchUsersMatesData('')
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      resetPageForSearch()
      fetchUsersMatesData(searchQuery)
    }
  }

  const submitSearch = () => {
    resetPageForSearch()
    fetchUsersMatesData(searchQuery)
  }

  const handleExportMates = () => {
    const payload: ExportReportPayload = {type: 'mates'}
    if (searchQuery?.trim()) payload.search = searchQuery.trim()
    runExport(payload)
  }

  return (
    <div>
      <p className='card-label fw-bold fs-3 mb-2'>Mates Management</p>
      {isLoading ? (
        <div className=' d-flex justify-content-center mt-10 align-items-center'>
          <div className='spinner-border text-primary'></div>
        </div>
      ) : (
        <div className={`card `}>
          <div className='card-header border-0 pt-5 d-flex justify-content-between'>
            <div>
              <SearchQueryData
                value={searchQuery}
                handleChange={handleSearchChange}
                handleKeyDown={handleKeyDown}
                fetchData={submitSearch}
                placeholder='Search mates'
              />
            </div>
            <div>
              {/* <button
                disabled={isLoading}
                type='button'
                className='btn btn-light-primary me-3'
                data-kt-menu-trigger='click'
                data-kt-menu-placement='bottom-end'
                onClick={() => setShowFilter(true)}
              >
                <KTIcon iconName='filter' className='fs-2' />
                Filter
              </button> */}
              <button
                type='button'
                className='btn btn-light-primary me-3'
                disabled={exporting}
                onClick={handleExportMates}
              >
                <KTIcon iconName='exit-up' className='fs-2' />
                {exporting ? 'Exporting...' : 'Export'}
              </button>
            </div>
          </div>
          <div className='card-body py-3'>
            <div className='table-responsive'>
              {mates.length > 0 ? (
                <table className='table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3'>
                  <thead>
                    <tr className='fw-bold text-muted'>
                      {/* <th className='w-25px'>
                        <div className='form-check form-check-sm form-check-custom form-check-solid'>
                          <input
                            className='form-check-input'
                            type='checkbox'
                            value='1'
                            data-kt-check='true'
                            data-kt-check-target='.widget-13-check'
                            checked={isAllChecked}
                            onChange={handleHeaderCheckboxChange}
                          />
                        </div>
                      </th> */}
                      <th className='min-w-250px'>Name</th>
                      <th className='min-w-140px'>Role</th>
                      <th className='min-w-50px'>
                        <p className='mb-1'>Existing Shrido User </p>
                        <p className='mb-0'>(Mates From Contacts)</p>
                      </th>
                      <th className='min-w-120px'>
                        <p className='mb-1'>Shrido Friends</p>
                        <p className='mb-0'> (Mates From Rides)</p>
                      </th>
                      <th className='min-w-120px'>Number Of Favorites</th>
                      <th className='min-w-120px'>Trips Taken With Other Favorites</th>
                      <th className='min-w-120px'>Trips Taken With Shrido friends</th>
                      <th className='min-w-120px'> Number Of Confirmed Referrals</th>
                      <th className='min-w-120px'> Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {mates.map((item: any, index: number) => {
                      return (
                        <tr key={index}>
                          {/* <td>
                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                              <input
                                className='form-check-input widget-13-check'
                                type='checkbox'
                                value='1'
                                checked={checkedMates.includes(item.id)}
                                onChange={() => handleCheckboxChange(item.id)}
                              />
                            </div>
                          </td> */}
                          <td>
                            <p className='text-dark fw-bold text-hover-primary fs-6'>{item.name}</p>
                          </td>
                          <td>
                            <p className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6 text-center'>
                              {item.role === 2
                                ? ' Driver'
                                : item.role === 3
                                ? ' Passenger'
                                : item.role === 4
                                ? ' Both'
                                : ' -'}
                            </p>
                          </td>
                          <td>
                            <p className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6 text-center'>
                              {item.mates_from_contact}
                            </p>
                          </td>
                          <td>
                            <p className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6 text-center'>
                              {item.mates_from_rides}
                            </p>
                          </td>
                          <td className='text-dark fw-bold text-hover-primary fs-6 text-center'>
                            {item.favourites_mates}
                          </td>
                          <td>
                            <p className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6 text-center'>
                              {item.trips_taken_with_favourite_contact_mates}
                            </p>
                          </td>{' '}
                          <td>
                            {' '}
                            <p className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6 text-center'>
                              {item.trips_taken_with_mates}
                            </p>
                          </td>
                          <td>
                            {' '}
                            <p className='text-dark fw-bold text-hover-primary d-block mb-1 fs-6 text-center'>
                              {item.total_referral}
                            </p>
                          </td>
                          <td>
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              onClick={() => navigate(`/mates-management/${item.id}`)}
                            >
                              <KTIcon iconName='eye' className='fs-1' />
                            </button>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              ) : (
                <p className='fs-5 pt-3 text-center'>Mates are not found</p>
              )}
            </div>
          </div>
        </div>
      )}
      {totalPages > 1 && <Pagination totalPages={totalPages} page={page} setPage={setPage} />}
    </div>
  )
}

export default MatesManagementWrapper
